import { render } from "./AuctionsSummaryWidget.vue?vue&type=template&id=03e09a0b&scoped=true&ts=true"
import script from "./AuctionsSummaryWidget.vue?vue&type=script&lang=ts"
export * from "./AuctionsSummaryWidget.vue?vue&type=script&lang=ts"

import "./AuctionsSummaryWidget.vue?vue&type=style&index=0&id=03e09a0b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e09a0b"]])

export default __exports__